import { NdtStep } from "./helpers";

export default function() {
    return NdtStep('step5', 'Step 5: Can you answer yes to either of these questions with regard to employer contributions toward major medical insurance coverage (i.e., general health insurance) offered under the plan?', {
        nextComponent() { return this.answer == true ? 'step6' : 'step5a' },
        passed: () => true,
        template: `
        <div>
            <question :question="question" v-model="answer">
                <template v-slot:definition>
                <div class="px-4 row">
                    <ul class="px-4">
                        <li class="mt-2">
                            Are the employer contributions the same as or more than the cost of major medical coverage provided to similarly situated HCEs (e.g., participants at the same benefit level)?<br/>
                            Example: For XYZ Inc., the cost of self-only (family) major medical insurance for self-only (family) HCEs is $500 ($1,000) a month. XYZ Inc contributes $500 a month to the major medical coverage of all participants with self-only coverage and $1,000 a month for all participants with family coverage. XYZ could answer “yes” to this question.
                        </li>
                        <li class="mt-2">
                            Are employer contributions to participants equal to or greater than 75% of the cost of the most expensive major medical coverage offered under the plan to similarly situated participants (e.g., participants at the same benefit level)?<br/>
                            Example: For XYZ Inc., the cost of the most expensive self-only (family) major medical insurance for self-only (family) HCEs is $1,000 ($2,000) a month. XYZ Inc contributes $750 a month to the major medical coverage of all participants with self-only coverage and $1,500 a month for all participants with family coverage. Because these contributions are at least 75% of the cost of the most expensive coverage, XYZ could answer “yes” to this question.
                        </li>
                    </ul>
                </div>
                </template>
            </question>
        </div>
    `,
    })
}


// WEBPACK FOOTER //
// ./src/shared/Nondiscrimination/POP/step5.js